$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/recruit/wp/wp-content/themes/saisho-recruit/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	// スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('open');
		return false;
	});

	//メニュー名以外の部分をクリックで閉じる
	$(document).on('click', function(e) {
		if(!$(e.target).is('.header_menu, .header_menu_nav, .header_menu_nav a, .submenu_btn')) {
			body.removeClass('open');
		}
	});

	//募集要項アコーディオン
	$('.header_r_accordion').on('click', function () {
		$(this).toggleClass('on');
		$(this).next().slideToggle();
		return false;
	});

	//ハンバーガーメニュー サブメニュー
	$('.header_menu_nav .submenu_btn').on('click', function () {
		$(this).toggleClass('on');
		$(this).parents(".submenu").toggleClass('on');
		$(this).next(".submenu_wrap").toggleClass('on');
		$(this).not(this).removeClass("on");
		$(this).not(this).parents(".submenu").removeClass("on");
		$(this).not(this).next().removeClass("on");
		$(this).next().slideToggle(300);
	});

	//ヘッダーナビゲーション サブメニュー
	$('.header_nav .submenu_btn').on('click', function () {
		$(this).toggleClass('on');
		$(this).parents(".submenu").toggleClass('on');
		$(this).parents(".header_nav_box").next(".submenu_wrap").toggleClass('on');
		$(this).next(".submenu_wrap").toggleClass('on');
		$(this).not(this).removeClass("on");
		$(this).not(this).parents(".submenu").removeClass("on");
		$(this).not(this).parents(".header_nav_box").next(".submenu_wrap").removeClass("on");
		$(this).not(this).next().removeClass("on");
		$(this).parents(".header_nav_box").next(".submenu_wrap").fadeIn(300);
	});

	//サブメニュー スクロールで追従
	$(window).on('load scroll resize', function() {
		scrollMenu();
		$(".header_nav_box").scroll(function() {
			// スクロールしたときの処理内容を記述する
			scrollMenu();
		});
	});
	function scrollMenu() {
		var result = $('#header_nav_submenu').position().left;
		$(".submenu_wrap").css({ left :result });
	}

	//ヘッダーナビゲーション サブメニュー スクロール位置変更 スマホ時
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			if ($(".list_job").hasClass('current')) {
				$(".list_job.current").parents(".header_nav_box").animate({scrollLeft: 115});
			}
			if ($(".list_interview").hasClass('current')) {
				const headerNavBox = $(".list_interview.current").parents(".header_nav_box");
				const maxScrollLeft = headerNavBox.get(0).scrollWidth - headerNavBox.width();
				headerNavBox.animate({scrollLeft: maxScrollLeft});
			}
			if ($(".list_news").hasClass('current')) {
				const headerNavBox = $(".list_news.current").parents(".header_nav_box");
				const maxScrollLeft = headerNavBox.get(0).scrollWidth - headerNavBox.width();
				headerNavBox.animate({scrollLeft: maxScrollLeft});
			}
		}
	});

	//動画ポップアップ
	$('.popup-youtube').magnificPopup({
		type: 'iframe',
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" allow="autoplay"></iframe>' +
				'</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: 'https://www.youtube.com/embed/%id%?autoplay=1'
				}
			}
		}
	});

	//背景画像パララックス 上
	const parallax_up = document.querySelector(".parallax_up");
	if (parallax_up !== null) {
		let target = document.getElementsByClassName("parallax_up");
			let parallaxConfig = {
				delay: 0, // スクロール止めてから動く秒数
				orientation: "up", // 動く方向
				scale: 1.5, // 動く大きさ
				overflow: true,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

	//インタビュースライド スマホ時
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			const swiper = new Swiper('.interview_swiper', {
				slidesPerView: 1.58,
				breakpoints: {
					320: {
						spaceBetween: 5,
					},
				},
			});
		}
	});

	//制度/福利厚生スライド スマホ時
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			const swiper = new Swiper('.benefits_swiper', {
				slidesPerView: 1.2,
				breakpoints: {
					320: {
						spaceBetween: 5,
					},
				},
			});
		}
	});


});